import React from 'react';
import TodoList from './TodoList';
function App() {
  return (
    <div className="App">
      <TodoList></TodoList>
    </div>
  );
}

export default App;